module.exports = __webpack_public_path__ + "img/PVP_TechUtilityBoat_Upgrade1_ua.4c15801e.webp";